import React from 'react'
import styled from '@emotion/styled'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
//AIRCRAFT INFO
import { Grid } from '@mui/material'
import { removeAcentos } from './../../Utils/stringUtils'
import { ButtonStyle } from '../ServicesStyledComponents'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'

const BOEInfoContainer = styled('div')(({ theme }) => ({
  fontSize: '.75em',
  width: '90%',
  color: theme.palette.primary.main,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    padding: '0 3rem',
  },
}))

export const BOEInputStyle = styled(TextField)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.only('xs')]: {
    marginTop: '0.5rem',
  },
  '& .MuiFormHelperText-root': {
    color: theme.palette.primary.main,
  },
}))

export const BOEFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiRadio-root': {
    color: theme.palette.primary.main,
  },
  '& .MuiTypography-root': {
    fontSize: '0.8rem',
  },
}))

function BOEInfo(props) {
  const { values, handleChange, setFieldValue, errors } = props.formikProps

  const removeAccentsOnBlur = (e) => {
    const { id, value } = e.target
    setFieldValue(id, removeAcentos(value || ''))
  }

  return (
    <BOEInfoContainer>
      <Grid container justify="center" alignItems="center" spacing={2}>
        <Grid item xs={12}>
          <FormControl required>
            <Typography
              variant="subtitle1"
              id="demo-row-radio-buttons-group-label"
              style={{ marginBottom: '1rem' }}
            >
              Please select the description that most accurately describes the
              type of Operations that you will be conducting with the BOE.
            </Typography>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="operationType"
              value={values.operationType}
              onChange={(e) => {
                handleChange(e)
                console.log('VALUES: ', values)
              }}
            >
              <Grid container justify="center" alignItems="center" spacing={2}>
                <Grid item xs={12} sm={4}>
                  <BOEFormControlLabel
                    onChange={handleChange}
                    value="COMMERCIAL_FULLY_COMPLIANT"
                    control={<Radio />}
                    label={
                      <Typography variant="caption" textAlign="center">
                        <strong>
                          Commercial Aircraft Operator, Fully Compliant
                        </strong>
                        <br />
                        The operator transports passengers and/or cargo for
                        payment or other considerations, maintains a Type 3
                        Carrier Bond, and is current with all applicable User
                        Fee remittance responsibilities.
                      </Typography>
                    }
                    labelPlacement="top"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <BOEFormControlLabel
                    onChange={handleChange}
                    value="COMMERCIAL_SEEKING_COMPLIANCE"
                    control={<Radio />}
                    label={
                      <Typography variant="caption" textAlign="center">
                        <strong>
                          Commercial Aircraft Operator, Seeking Compliance
                        </strong>
                        <br />
                        The operator transports passengers and/or cargo for
                        payment or other considerations, but does not yet
                        maintain a Type 3 Carrier Bond, and/or is not current
                        with all applicable User Fee remittance
                        responsibilities.
                      </Typography>
                    }
                    labelPlacement="top"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <BOEFormControlLabel
                    onChange={handleChange}
                    value="PRIVATE_OPERATOR"
                    control={<Radio />}
                    label={
                      <Typography variant="caption" textAlign="center">
                        <strong>Private Aircraft Operator</strong>
                        <br />
                        The operator never transports passengers or cargo for
                        payment or other considerations.
                      </Typography>
                    }
                    labelPlacement="top"
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>
        {values.operationType !== 'PRIVATE_OPERATOR' ? (
          <>
            <Grid item xs={12}>
              <BOEInputStyle
                id="carrierCode"
                // focused
                onChange={handleChange}
                onBlur={removeAccentsOnBlur}
                name="carrierCode"
                label="Carrier Code*"
                value={values['carrierCode']}
                error={!!errors.carrierCode}
                helperText={errors?.carrierCode}
                size="small"
                inputProps={{ maxLength: 3 }}
              />
            </Grid>
            <Grid item xs={12}>
              <BOEInputStyle
                id="type3CarrierBond"
                // focused
                onChange={handleChange}
                onBlur={removeAccentsOnBlur}
                name="type3CarrierBond"
                label="Type 3 Carrier Bond*"
                value={values['type3CarrierBond']}
                error={!!errors.type3CarrierBond}
                helperText={
                  errors?.type3CarrierBond
                    ? errors?.type3CarrierBond
                    : 'Please enter your Type 3 Carrier Bond number. Failing to provide number may delay the processing of your BOE'
                }
                size="small"
              />
            </Grid>
          </>
        ) : null}
        {/* <Grid item xs={12}>
          <BOEInputStyle
            id="notes"
            multiline
            rows={3}
            onChange={(e) => {
              // console.log('VALUES: ', values)
              handleChange(e)
            }}
            onBlur={removeAccentsOnBlur}
            name="notes"
            value={values['notes']}
            error={!!errors.notes}
            placeholder="Please enter any other pertinent information that should be included with your BOE application for a NEW or a RENEWAL BOE."
            helperText={
              errors?.notes
                ? errors?.notes
                : 'Please enter any other pertinent information that should be included with your BOE application for a NEW or a RENEWAL BOE.'
            }
            size="small"
          />
        </Grid> */}
        {values.boeType ? null : (
          <Grid
            container
            item
            xs={12}
            sm={4}
            justifyContent="center"
            alignItems="center"
          >
            <ButtonStyle
              variant="contained"
              onClick={() => {
                console.log('VALIDATING EXISTING BOE PERMIT')
              }}
            >
              Next
            </ButtonStyle>
          </Grid>
        )}
      </Grid>
    </BOEInfoContainer>
  )
}

export default BOEInfo
